<template>
  <span>
    <button
      type="button"
      class="btn btn-outline-danger btn-xs mr-1"
      :disabled="disabled"
      @click="toggle"
    >
      <i class="fas fa-sign-out-alt"></i>&nbsp;Logout croupier
    </button>
    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      title="Confirm logout croupier?"
      hide-footer
    >
      <span> {{ message }}: {{ object }}. </span>
      <b-button class="mt-2 float-right" variant="danger" @click="handleSubmit"
        >Logout</b-button
      >
    </b-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false
    }
  },
  components: {},
  props: ['object', 'message', 'url', 'removeHandler', 'disabled'],
  methods: {
    resetModal() {},
    hideModal() {
      this.$refs['modal-container'].hide()
    },
    toggle() {
      this.modalShow = !this.modalShow
    },
    handleSubmit() {
      if (this.removeHandler) {
        this.removeHandler(this)
        return
      }

      this.$http({
        url: this.url,
        method: 'post',
        data: {
          apiKey: process.env.VUE_APP_CHAT_API_KEY
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish')
          }, 500)

          this.hideModal()
          this.$toastr.i('Success')
        })
        .catch(err => {
          this.$toastr.e(JSON.stringify(err.response.data.message))

          throw err
        })
    }
  },
  computed: {},
  watch: {},
  mounted() {}
}
</script>
